import React, { type ReactElement, type ReactNode } from 'react';

import classnames from 'classnames';

import styles from './ContentBox.module.scss';

type ContentBoxProps = {
    className?: string;
    children: ReactNode;
    inner?: boolean;
    noPadding?: boolean;
};

const ContentBox = ({ className, children, inner, noPadding }: ContentBoxProps): ReactElement => {
    return (
        <div
            className={classnames(
                styles.container,
                { [styles.inner]: inner, [styles.noPadding]: noPadding },
                className
            )}
        >
            {children}
        </div>
    );
};

export default ContentBox;
